import React, { useEffect, useRef, useState } from 'react';
import Konva from 'konva';
import { TGDComponent } from '../../../models/courses/graphicDesign';
import { resolveFontFamily } from '../core/fonts';

interface GDTextEditorProps {
  component: TGDComponent; node: Konva.Text; scale: number;
  onCommit: (text: string) => void; onClose: () => void;
}

const GDTextEditor: React.FC<GDTextEditorProps> = ({ component, node, scale,
  onCommit, onClose }) => {
  const [text, setText] = useState(component.text ?? '');
  const field = useRef<HTMLTextAreaElement>(null);
  const finished = useRef(false);
  const rect = node.getClientRect();
  const container = node.getStage()?.container();
  const parent = container?.parentElement?.getBoundingClientRect();
  const stage = container?.getBoundingClientRect();
  const finish = () => {
    if (finished.current) return;
    finished.current = true;
    onCommit(text.trim() ? text : component.text ?? '');
    onClose();
  };
  useEffect(() => { field.current?.focus(); field.current?.select(); }, []);
  return <textarea ref={field} className="gd-text-editor" value={text}
    aria-label="Modifier le texte" dir={component.direction ?? 'ltr'}
    onChange={event => setText(event.target.value)} onBlur={finish}
    onKeyDown={event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        finished.current = true;
        onClose();
      }
      if (event.key === 'Enter' && !event.shiftKey) { event.preventDefault(); finish(); }
    }}
    style={{ left: (stage?.left ?? 0) - (parent?.left ?? 0) + rect.x,
      top: (stage?.top ?? 0) - (parent?.top ?? 0) + rect.y,
      width: Math.max(44, rect.width), height: Math.max(44, rect.height),
      fontFamily: resolveFontFamily(component), fontSize: (component.fontSize ?? 16) * scale,
      color: component.fill, textAlign: component.align ?? 'left' }} />;
};

export default GDTextEditor;
